// Toast.js
import React from 'react'
import ReactDOM from 'react-dom'
import './index.less'

let toastContainer = null

const Toast = ({ message }) => {
  if (!message) return null

  return ReactDOM.createPortal(
    <div className="toast">
      {message}
    </div>,
    toastContainer
  )
}

const showToast = (message, duration = 2000) => {
  if (!toastContainer) {
    toastContainer = document.createElement('div')
    document.body.appendChild(toastContainer)
  }

  // Render the Toast component
  ReactDOM.render(<Toast message={message} />, toastContainer)

  // Automatically remove Toast after the specified duration
  setTimeout(() => {
    ReactDOM.unmountComponentAtNode(toastContainer)
    toastContainer = null
  }, duration)
}

export default showToast



// WEBPACK FOOTER //
// src/pages/activity/national-star/toast/index.js